import React from "react";

import { Box, ClickAwayListener } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import SearchFoodPanel from "./MealPlannerForm/SearchFoodPanel";
import MealPlanFormStore from "./store/MealPlanFormStore";

export interface MealPlanFormContainer {
  store: MealPlanFormStore;
  header: React.ReactElement;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
  },
  form: {
    background: theme.palette.common.white,
    padding: theme.spacing(4),
    overflow: "hidden",
    marginTop: theme.spacing(0.5),
  },
  formShrunk: {
    width: "70%",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  formExpanded: {
    width: "100%",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
}));

const MealPlanFormContainer: React.FC<MealPlanFormContainer> = observer(
  ({ store, header, children }) => {
    const { classes, cx } = useStyles();

    const foodDatabaseOpen = !!store.cells.active;

    return (
      <MealPlanFormStore.Context.Provider value={store}>
        <ClickAwayListener onClickAway={() => store.cells.clearActive()}>
          <div className={classes.root}>
            <div
              className={cx(classes.form, {
                [classes.formShrunk]: foodDatabaseOpen,
                [classes.formExpanded]: !foodDatabaseOpen,
              })}
            >
              {header}
              <Box marginBottom={5} />
              {children}
            </div>
            <SearchFoodPanel />
          </div>
        </ClickAwayListener>
      </MealPlanFormStore.Context.Provider>
    );
  }
);

export default MealPlanFormContainer;
